import { AxiosHttpService } from "services/AxiosHttpService";
import { IEmployeeRepository } from "../repository/employees/repository";
import { EmployeeRepository } from "../repository/employees/EmployeeRepository";
import { createApiClient } from "utils/AxiosClient";
import { ICacheService } from './ICacheService';
import { CacheService } from 'services/CacheService';

export class EmployeeService {
    private cacheService: ICacheService;
    private httpService: IHttpService

    public employee: IEmployeeRepository

    constructor(url?: string) {
            this.cacheService = new CacheService('tk-cache-db');
        const baseURL = url ? url : `${process.env.REACT_APP_TK_GW_DOMAIN}/v1/employee`;
        const apiClient = createApiClient(baseURL)
        this.httpService = new AxiosHttpService(apiClient, this.cacheService);

        this.employee = new EmployeeRepository(this.httpService);

    }
}
